import { Image, Placeholder } from "@aws-amplify/ui-react"

const ExerciseDetailsCard = ({ exercise, isLoading }) => {

    return (
        <div>

            {exercise &&
                <div className="text-align-start mx-1 row" >

                    <div className="col-12 col-lg-6">
                        {exercise?.timestamp &&
                            <div>
                                <p className="label">Created:</p>
                                {!isLoading &&
                                    <p>{(new Date(exercise?.timestamp)).toLocaleDateString()}</p>
                                }
                                <Placeholder isLoaded={!isLoading} style={{ height: '2rem' }} />
                            </div>
                        }

                        {exercise?.description &&
                            <div>
                                <p className="label">Description:</p>
                                {!isLoading &&
                                    <p>{exercise?.description}</p>
                                }
                                <Placeholder isLoaded={!isLoading} style={{ height: '4rem' }} />
                            </div>
                        }
                        {exercise?.group &&
                            <div>
                                <p className="label">Muscle Group:</p>
                                {!isLoading &&
                                    <p>{exercise?.group}</p>
                                }
                                <Placeholder isLoaded={!isLoading} style={{ height: '2rem' }} />
                            </div>
                        }
                    </div>
                    <div className="col-12 col-lg-6">
                        {exercise?.picture &&
                            <Image
                                alt="Example"
                                src={exercise?.picture}
                                objectFit="initial"
                                objectPosition="50% 50%"
                                backgroundColor="initial"
                                opacity="100%" />
                        }
                    </div>

                </div>
            }
        </div>
    )
}

export default ExerciseDetailsCard